/// <reference path="../../lib/app.d.ts" />

import {JoinedRoomData} from "../chatserver/sx-server";
export class RoomData
{
	roomData : JoinedRoomData;

	constructor(private roomID : string)
	{
	}

	setJoinData(data : JoinedRoomData)
	{
		this.roomData = data;
	}

	getScreenName() : string
	{
		return this.roomData && "screenName" in this.roomData ? this.roomData.screenName : null;
	}

	getID() : string
	{
		return this.roomID.toString();
	}

	isPrivateAllowed():any
	{
		return this.roomData.allowedModes.indexOf("private") > -1;
	}

	isExclusiveAllowed():any
	{
		return this.roomData.allowedModes.indexOf("exclusive") > -1;
	}

	isGroupAllowed():any
	{
		return this.roomData.allowedModes.indexOf("group") > -1;
	}

	isFreeAllowed():any
	{
		return this.roomData.allowedModes.indexOf("free") > -1;
	}

	isVoyeurAllowed():any
	{
		return "canJoin" in this.roomData.modeSpecific && this.roomData.modeSpecific.canJoin;
	}

	getPrivatePrice():any {
		return this.roomData.pricing.private;
	}

	getExclusivePrice():any {
		return this.roomData.pricing.exclusive;
	}

	getGroupPrice():any {
		return this.roomData.pricing.group;
	}

	getVoyeurPrice():any {
		return this.roomData.pricing.voyeur;
	}

	isVoyeur()
	{
		return "privateMode" in this.roomData.modeSpecific && this.roomData.modeSpecific.privateMode == "voyeur";
	}

	getProfilePic()
	{
		return "profilePic" in this.roomData.publicData ? this.roomData.publicData.profilePic : null;
	}

	getRoomMode()
	{
		return this.roomData.roomMode;
	}

	isVisitX()
	{
		// const isExternal = isNaN(parseInt(room, 10))
		return this.roomID.substr(0,1) === "v";
	}
}
